import logoOmniva from '../img/logos/omniva.svg';
import logoSmartpost from '../img/logos/smartpost.svg';
import logoUnisend from '../img/logos/unisend.svg';
import logoVenipak from '../img/logos/venipak.svg';

export const ProviderIcons: { [key: string]: any } = {
  omniva: logoOmniva, itella: logoSmartpost, unisend: logoUnisend, venipak: logoVenipak
};